export enum CartItemTypes {
  Product = 'Product',
  Package = 'Package',
  Ticket = 'Ticket',
  Voucher = 'Voucher',
  CancelTicket = 'CancelTicket',
  CancelProduct = 'CancelProduct',
  CancelPackage = 'CancelPackage',
  CancelVoucher = 'CancelVoucher',
  CashVoucher = 'CashVoucher',
  ExternalVoucher = 'ExternalVoucher',
  Card = 'Card',
  LoadCard = 'LoadCard',
  CancelCard = 'CancelCard',
  CashCineCard = 'CashCineCard'
}
